import axios from 'axios';
import { getLoggedInUserRole, getLoggedInUsername, getUserIdFromToken } from '../utils/auth';
import { formatDateLocal } from '../utils/reportDateRange';

export const FETCH_DATEWISE_SALE_REQUEST = 'FETCH_DATEWISE_SALE_REQUEST';
export const FETCH_DATEWISE_SALE_SUCCESS = 'FETCH_DATEWISE_SALE_SUCCESS';
export const FETCH_DATEWISE_SALE_FAILURE = 'FETCH_DATEWISE_SALE_FAILURE';

const base_url = process.env.REACT_APP_API_URL_ADMIN;

export const getDateWiseSaleReport = ({ startDate, endDate, companyId }) => async (dispatch) => {
  dispatch({ type: FETCH_DATEWISE_SALE_REQUEST });
  try {
    const role = getLoggedInUserRole();
    const loggedInUsername = getLoggedInUsername();
    const userId = getUserIdFromToken();
    const response = await axios.post(`${base_url}`, {
      apiName: 'reporting',
      command: 'getAllReportsDatewise',
      FromDate: formatDateLocal(startDate),
      ToDate: formatDateLocal(endDate),
      company_id: companyId,
      role,
      userId,
      username: loggedInUsername,
      loggedInUserRole: role,
      loggedInUsername,
    });
    dispatch({ type: FETCH_DATEWISE_SALE_SUCCESS, payload: response.data.data });
  } catch (error) {
    dispatch({
      type: FETCH_DATEWISE_SALE_FAILURE,
      payload: error.response?.data?.message || 'Failed to fetch sale report',
    });
  }
};
